export default __webpack_public_path__ + "static/media/cloudcma.9a9105b6.png";